import { toast } from "react-toastify";
import i18n from "i18next";

import { SaveResponse } from "../../models/api/save/save.response";
import { LoadResponse } from "../../models/api/load/load.response";
import { DTOModel } from "../../models/base/dto-model";
import { OVERRIDEN_ERROR_MESSAGES } from "./overriden-error-messages";

export const toastifyResponse = (
  response: SaveResponse | LoadResponse<DTOModel>,
  showMessages: "all" | "failed" = "all",
  successMessage: string = "default_success_message",
  cancellationMessage: string = "default_cancellation_message",
  errorMessage: string = "default_error_message"
): void => {
  const tRP = "components.toast"; // tRP - translationRootPath

  const { isSucceeded, isCanceled, error } = response;
  let message = "";

  if (isSucceeded) {
    message = i18n.t(`${tRP}.${successMessage}`);
    if (showMessages === "all") toast.success(message, { autoClose: 10000 });
  } else if (OVERRIDEN_ERROR_MESSAGES.includes(error) && !isCanceled) {
    message = `${error}`;

    toast(message, { autoClose: 10000, className: "warning-toastifier" });
    throw message;
  } else if (error === "canceled" || isCanceled) {
    message = `${i18n.t(`${tRP}.default_canceled_message`)}`;

    toast(message, { autoClose: 10000, className: "cancel-toastifier" });
    throw message;
  } else if (error && !isCanceled) {
    message = `${i18n.t(`${tRP}.${errorMessage}`)} ${error ?? ""}`;
    toast.error(message, { autoClose: 10000 });
    throw message;
  }
};
